// extracted by mini-css-extract-plugin
export default {"showimage":"ShowImge_showimage__pX+eN","centerdiv":"ShowImge_centerdiv__VTB1p","close":"ShowImge_close__6VYHe","animate-rotate":"ShowImge_animate-rotate__TSHDe"};